import React, { useContext, useState } from 'react';
import Label from "components/general/Label"
import { completeRsc, getLevelRSC, getLongEventRSC } from 'helpers/rsc';
import { useGetPath, useGetURL, useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { Container, Dropdown, Nav, Navbar, Placeholder, Stack } from 'react-bootstrap';
import { ALL_URL, GetIsAINOrNPA, GetNocMedalAndParticipant, TYPE_DATA, sortDataByField } from 'helpers/utils';
import { useGetConfigSports, useGetDisciplines, useGetEvents } from 'helpers/commonCodes';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import { ItemDiscipline } from '../selectors/selector-discipline/selectorDisciplineMenu';
import Collapse from 'react-bootstrap/Collapse';
import { MainContainerContext } from './MainContainer';
import useViewport from 'components/general/useViewPort';


//const arrowDown = <span className="mirsIconOpen" />
//const arrowUp = <span className="mirsIconClose" />

const NavbarSecondaryElements = () => {
    const params = useUrlFriendlyToParameters();
    let paramsURL = { ...params }
    let obj = useGetPath()
    const getUrl = useGetURL()
    let objUrl = obj(paramsURL.mirs_language);
    const { breakPoint } = useViewport();
    const isMobile = breakPoint === "sm" || breakPoint === "xs"

    //Change object if make changes over params make changes in componets related   (Change URL object)
    paramsURL.mirs_rsc = getLongEventRSC(paramsURL.mirs_rsc || paramsURL.mirs_event)
    const dataConfigSport = useGetConfigSports(paramsURL);
    const isH2H = dataConfigSport?.isH2H
    const hasPool = dataConfigSport?.hasPool
    const hasTodayMatches = dataConfigSport?.hasTodayMatches
    const showCompetitionStatus = dataConfigSport?.showCompetitionStatus

    let hasBracket = dataConfigSport?.hasBracket ? dataConfigSport?.hasBracket : isH2H ? true : false
    let hasRanking = dataConfigSport && dataConfigSport.hasOwnProperty("hasRanking") ? dataConfigSport?.hasRanking : isH2H ? true : false
    const hasRecords = process.env.REACT_APP_RECORDS_ARRAY.includes(paramsURL.mirs_discipline)
    const hasResults = getLevelRSC(paramsURL.mirs_event) === "EVENT" || getLevelRSC(paramsURL.mirs_event) === "PHASE" || getLevelRSC(paramsURL.mirs_event) === "UNIT"

    if (dataConfigSport && dataConfigSport.hasOwnProperty("exceptionRanking") && dataConfigSport?.exceptionRanking.includes(paramsURL.mirs_rsc)) {
        hasRanking = false;
    }
    if (dataConfigSport && dataConfigSport.hasOwnProperty("exceptionBracket") && dataConfigSport?.exceptionBracket.includes(paramsURL.mirs_rsc)) {
        hasBracket = false;
    }
    let urlMultiMedallists = getUrl(paramsURL, 'multimedallists')
    let urlMedallists = getUrl(paramsURL, 'medallists')
    let urlMedal = getUrl(paramsURL, 'medal')
    let urlTeams = getUrl(paramsURL, 'teams')
    let urlCoaches = getUrl(paramsURL, 'coaches')
    let urlTechnicalOfficials = getUrl(paramsURL, 'technicalofficials')
    let urlHorses = getUrl(paramsURL, 'horses')
    let urlNocList = getUrl(paramsURL, 'noclist')
    let urlEntriesByDiscipline = getUrl(paramsURL, 'entriesbydiscipline')
    let urlScheduleByNoc = getUrl(paramsURL, 'schedulebynoc')
    let urlEntriesByNoc = getUrl(paramsURL, 'entriesbynoc')
    let urlAthletesByNoc = getUrl(paramsURL, 'athletesbynoc')
    let urlMedallistsByNoc = getUrl(paramsURL, 'medallistsbynoc')
    let urlProfileByNoc = getUrl(paramsURL, 'profilebynoc')
    let out
    const eventInUrl = isSchOrRec({ urlData: objUrl.url }) && paramsURL.mirs_event && paramsURL.mirs_event !== ALL_URL.ALL_EVENT;
    const showRanking = objUrl.url.isResult || objUrl.url.isPool || objUrl.url.isBracket || objUrl.url.isRanking || eventInUrl
    let isNocMedalAndParticipant = GetNocMedalAndParticipant({ ...params });
    if (objUrl.url.isCompetitionSchedule) {
        out = <>
            <div id="activity-list-link" className="d-none navbar-nav swiperSlide"><a className="nav-link" href="#"><Label data={'LabelActivityList'} /></a></div>
            <div id="non-competition-schedule-link" className="d-none navbar-nav swiperSlide"><a className=" nav-link" href="#"><Label data={'LabelNonCompetitionSchedule'} /></a></div>
        </>
    } else if ((objUrl.url.isResult ||
        objUrl.url.isEntries ||
        objUrl.url.isPool ||
        objUrl.url.isBracket ||
        objUrl.url.isRecords ||
        objUrl.url.isRanking)
        && paramsURL.mirs_discipline
        && paramsURL.mirs_discipline !== ALL_URL.ALL_DISC) {

        /* RESULTS*/
        out = <>
            <ElementMenuSchedule paramsURL={paramsURL} label={'Schedule'} />
            <ElementMenuEvents />
            {hasResults && <ElementMenuResults paramsURL={paramsURL} active={objUrl.url.isResult} />}
            {hasTodayMatches && !isMobile && <ElementMenuTodayMatches paramsURL={paramsURL} />}
            <ElementMenuEntries paramsURL={paramsURL} />
            {isH2H && hasPool && <ElementMenuGroups active={objUrl.url.isPool} discipline={paramsURL.mirs_discipline} />}
            {hasBracket && <ElementMenuBrackets active={objUrl.url.isBracket} />}
            {hasRanking && showRanking && <ElementMenuRanking paramsURL={paramsURL} />}
            <ElementMenuReports paramsURL={paramsURL} />
            {hasRecords && <ElementMenuRecords paramsURL={paramsURL} />}
            {showCompetitionStatus && <ElementCompetitionStatus paramsURL={paramsURL} />}

        </>

    } else if (objUrl.url.isEntries && paramsURL.mirs_discipline && paramsURL.mirs_discipline !== ALL_URL.ALL_DISC) {
        /* ENTRIES NO DISCIPLINE*/
        out = <>
            <ElementMenuEntries paramsURL={paramsURL} />
            <ElementMenuReports paramsURL={paramsURL} />
            {hasRecords && <ElementMenuRecords paramsURL={paramsURL} />}
        </>
    } else if (
        (objUrl.url.isSchedule || objUrl.url.isCompetitionStatus || objUrl.url.isHearingSchedule || objUrl.url.isReports ||
            objUrl.url.isTodayAthMatches || objUrl.url.isTodayMatches || objUrl.url.isTodayTeamMatches) &&
        paramsURL.mirs_discipline && paramsURL.mirs_discipline !== ALL_URL.ALL_DISC
    ) {
        /**  SCHEDULES*/
        out = <>
            <ElementMenuSchedule paramsURL={paramsURL} label={'Schedule'} />
            {hasTodayMatches && !isMobile && <ElementMenuTodayMatches paramsURL={paramsURL} />}
            <ElementMenuEvents />
            <ElementMenuEntries paramsURL={paramsURL} />
            {isH2H && hasPool && <ElementMenuGroups />}
            {hasBracket && <ElementMenuBrackets />}
            {hasRanking && showRanking && <ElementMenuRanking paramsURL={paramsURL} />}
            <ElementMenuReports paramsURL={paramsURL} />
            {hasRecords && <ElementMenuRecords paramsURL={paramsURL} />}
            {showCompetitionStatus && <ElementCompetitionStatus paramsURL={paramsURL} />}

        </>
    } else if (objUrl.url.isMedal || objUrl.url.isMedallists || objUrl.url.isMultiMedallists) {
        /**  MEDALIST*/
        out = <>
            <Nav.Link as={CustomLink} id="OCSMenuMedalStandings" to={urlMedal}><Label data={'MedalStandings'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuMedallists" to={urlMedallists}><Label data={'LabelMedallists'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuMultiMedallists" to={urlMultiMedallists}><Label data={'MultiMedallists'} /></Nav.Link>
        </>
    } else if (objUrl.url.isAthletes || objUrl.url.isTeams || objUrl.url.isCoaches || objUrl.url.isTechnicalOfficials || objUrl.url.isHorses || objUrl.url.isNocList || objUrl.url.isEntriesDiscipline) {
        /** CATEGORIES */
        out = <>
            <ElementMenuAthletes paramsURL={paramsURL} label={'LabelAthletes'} active={objUrl.url.isAthletes} />
            <Nav.Link as={CustomLink} id="OCSMenuTeams" to={urlTeams} active={objUrl.url.isTeams}><Label data={'Teams'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuCoaches" to={urlCoaches} active={objUrl.url.isCoaches}><Label data={'Coaches'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuOfficials" to={urlTechnicalOfficials} active={objUrl.url.isTechnicalOfficials}><Label data={'TechnicalOfficials'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuHorses" to={urlHorses} active={objUrl.url.isHorses}><Label data={'Horses'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuNocList" to={urlNocList} active={objUrl.url.isNocList}><Label data={'LabelNocs'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuEntriesDiscipline" to={urlEntriesByDiscipline} active={objUrl.url.isEntriesDiscipline}><Label data={'LabelEntriesDiscipline'} /></Nav.Link>
        </>
    } else if (objUrl.url.isScheduleByNoc || objUrl.url.isEntriesByNoc || objUrl.url.isMedallistsByNoc || objUrl.url.isProfileByNoc || objUrl.url.isAthletesByNoc) {
        /* NOCS*/
        out = <>
            <Nav.Link as={CustomLink} id="OCSMenuScheduleByNoc" to={urlScheduleByNoc}><Label data={'LabelSchedule'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuEntriesByNoc" to={urlEntriesByNoc}><Label data={'LabelEntries'} /></Nav.Link>
            <Nav.Link as={CustomLink} id="OCSMenuMedallistByNoc" to={urlMedallistsByNoc}><Label data={'NocMedallists'} /></Nav.Link>
            {/* <Nav.Link as={CustomLink} id="OCSMenuProfileByNoc" to={urlProfileByNoc}><Label data={'LabelProfile'} /></Nav.Link> */}
            {isNocMedalAndParticipant && <Nav.Link as={CustomLink} id="OCSMenuProfileByNoc" to={urlProfileByNoc}><Label data={'LabelProfile'} /></Nav.Link>}
            <Nav.Link as={CustomLink} id="OCSMenuAthleteByNoc" to={urlAthletesByNoc}><Label data={'LabelAthletes'} /></Nav.Link>
        </>
    }

    return (
        <>
            <Navbar.Toggle aria-controls="navbar-results" />

            <Navbar.Collapse id="navbar-results" >
                <div className='navbar-group'>
                    <Nav role='list' navbar={false} className="d-flex flex-row flex-nowrap">
                        {out}
                    </Nav>
                </div>
            </Navbar.Collapse>

        </>
    )
};


function ElementMenuEvents() {
    const params = useUrlFriendlyToParameters();
    const [isSport, setIsSport] = useState(false);
    const [show, setShow] = useState(false);
    const [element, setElement] = useState("");
    const dataDiscipline = useGetDisciplines(params);
    const discipline = dataDiscipline?.disciplines?.find(item => item.code === params.mirs_discipline)?.description
    const sports = dataDiscipline?.disciplines?.filter(item => item?.isSport && item?.scheduled);
    sortDataByField(sports, "description", true, TYPE_DATA.STRING);
    const handleOnSelect = (key => {
        if (key === 'sports') {
            setIsSport(true)
        }
    })
    return (
        <>
            <Dropdown
                show={show}
                onToggle={(nextShow, meta) => {
                    if (meta?.source !== "select") {
                        setShow(nextShow);
                        setIsSport(false)
                    }
                }}
                onSelect={handleOnSelect}
                id="OCSMenuEvents" role='listitem' className={"selectorContainer"} >
                <Dropdown.Toggle><Label data="HeaderEvents" /></Dropdown.Toggle>
                <Dropdown.Menu as='ul' title={element} >
                    {isSport ? (
                        <SportsItems data={sports} />
                    ) :
                        <EventsItems discipline={discipline} page={"schedule"} />
                    }
                </Dropdown.Menu>
            </Dropdown >
        </>
    )
}

function ElementMenuResults({ active }) {
    const { expandedComponent, resultBtn } = React.useContext(MainContainerContext);
    const { open, setOpen } = expandedComponent;
    const { showBtnResults, setShowBtnResults } = resultBtn;

    const handleClick = () => {
        setOpen(!open);
    }

    return (
        <>
            {showBtnResults && <div id="OCSMenuResults" role='listitem' className={`selectorContainer dropdown ${active ? "active" : ""} `}  >
                <button type="button" onClick={(e) => handleClick()} aria-expanded={open} className="dropdown-toggle btn btn-primary"><Label data={'ResultsSort'} /> </button>
            </div>}
        </>
    )
}

function ElementMenuTodayMatches({ paramsURL }) {
    const { mirs_event, mirs_language } = paramsURL
    const isJudIndiv = /JUD.*/.test(mirs_event) && !/JUD.TEAM.*/.test(mirs_event)
    let obj = useGetPath()
    let objUrl = obj(mirs_language)

    const label = objUrl?.url?.isTodayAthMatches || isJudIndiv ? 'LabelTodayContests' : 'LabelTodayMatches'
    const type = objUrl?.url?.isTodayAthMatches || isJudIndiv ? 'todayathmatches' : 'todaymatches'

    const getUrl = useGetURL()
    const urlTodayMatches = getUrl(paramsURL, type)

    let out = <><Nav.Link id="OCSMenuTodayMatches" as={CustomLink} to={urlTodayMatches}><Label data={label} /></Nav.Link></>

    return out;
}

function ElementCompetitionStatus({ paramsURL }) {
    const getUrl = useGetURL()
    const urlCompetitionStatus = getUrl(paramsURL, 'competitionstatus')
    const urlHearingSchedule = getUrl(paramsURL, 'hearingschedule')
    const out = (<>
        <Nav.Link id="OCSMenuCompetitionStatus" as={CustomLink} to={urlCompetitionStatus}><Label data={'LabelCompetitionStatus'} /></Nav.Link>
        <Nav.Link id="OCSMenuHearingSchedule" as={CustomLink} to={urlHearingSchedule}><Label data={'LabelHearingSchedule'} /></Nav.Link>
    </>)

    return out;
}

function ElementMenuRanking({ paramsURL }) {
    const getUrl = useGetURL()
    let urlRanking = getUrl(paramsURL, 'ranking')
    return (
        <Nav.Link id="OCSMenuRanking" as={CustomLink} to={urlRanking} > <Label data={'LabelRanking'} /></Nav.Link>
    )

}

function ElementMenuEntries({ paramsURL }) {
    const getUrl = useGetURL()
    const urlEntries = getUrl(paramsURL, 'entries')
    return (
        <Nav.Link id="OCSMenuEntries" as={CustomLink} to={urlEntries}><Label data={'MenuEntries'} /></Nav.Link>
    )
}

function ElementMenuReports({ paramsURL }) {
    const getUrl = useGetURL()
    let urlReports = getUrl(paramsURL, 'reports')
    return (
        <Nav.Link id="OCSMenuReports" as={CustomLink} to={urlReports}><Label data={'Reports'} /></Nav.Link>
    )
}

function ElementMenuRecords({ paramsURL }) {
    const getUrl = useGetURL()
    let urlRecords = getUrl(paramsURL, 'records')
    return (
        <Nav.Link id="OCSMenuRecords" as={CustomLink} to={urlRecords}><Label data={'LabelRecords'} /></Nav.Link>
    )
}


function ElementMenuSchedule({ paramsURL, label }) {
    const getUrl = useGetURL()
    paramsURL["mirs_date"] = ''
    let urlSchedule = getUrl(paramsURL, 'schedule')
    return (
        <Nav.Link id="OCSMenuSchedule" as={CustomLink} to={urlSchedule}><Label data={label} /></Nav.Link>
    )

}

function ElementMenuAthletes({ paramsURL, label }) {
    const getUrl = useGetURL()
    let urlAthletes = getUrl(paramsURL, 'athletes')
    return (
        <Nav.Link id="OCSMenuAthletes" as={CustomLink} to={urlAthletes}><Label data={label} /></Nav.Link>
    )
}

function ElementMenuBrackets({ active }) {

    return (
        <>
            <Dropdown id="OCSMenuBrackets" role='listitem' className={`selectorContainer ${active ? "active" : ""} `}  >
                <Dropdown.Toggle><Label data="LabelBrackets" /></Dropdown.Toggle>
                <Dropdown.Menu as='ul' title={<Label data="LabelBrackets" />} renderOnMount={true}>
                    <EventsItems page={"bracket"} />
                </Dropdown.Menu>
            </Dropdown >
        </>
    )
}

function ElementMenuGroups({ active, discipline }) {
    let isDisciplinesGroup = ['BDM', 'BKB', 'BKG', 'FBL', 'HBL', 'WPO'].includes(discipline)
    return (
        <>
            <Dropdown id="OCSMenuGroups" role='listitem' className={`selectorContainer ${active ? "active" : ""} `} >
                <Dropdown.Toggle>{isDisciplinesGroup ? <Label data="Groups" /> : <Label data="HeaderPools" />}</Dropdown.Toggle>
                <Dropdown.Menu as='ul' title={<Label data="HeaderPools" />} renderOnMount={true}>
                    <EventsItems page={"pool"} />
                </Dropdown.Menu>
            </Dropdown >
        </>
    )
}



//HOC (Higth Order Component) component Link in order to style selected
function CustomLink({ children, id, to, ...props }) {
    let resolved = useResolvedPath(to);
    let match = useMatch({ path: resolved.pathname, end: true });
    return (
        <div id={id} role='listitem' className={`navbar-nav ${match ? "active" : ""} `} >
            <Link to={to}{...props} >
                {children}
            </Link>
        </div>
    );
}

function listLinks({ children, id, to, ...props }) {
    return (
        <li id={id}>
            <Link to={to}{...props} >
                {children}
            </Link>
        </li>
    );
}

function SportsItems({ data }) {
    let params = useUrlFriendlyToParameters();
    const getURL = useGetURL()
    //Copy object in order to change 
    let paramsURL = { ...params }
    paramsURL["mirs_date"] = ''
    paramsURL["mirs_event"] = ''
    let url
    return (
        <>
            <Dropdown.Item key={"Selector-Event-Sport"} as='li' eventKey="sports"><Label data={'LabelSports'} /></Dropdown.Item>
            <Dropdown.Divider aria-hidden="true" />
            {Array.isArray(data) && data?.map((item, index) => {
                paramsURL["mirs_discipline"] = item.code
                url = getURL(paramsURL, "schedule")
                return (
                    <Dropdown.Item key={"Selector-Discipline-" + item.code} as={listLinks} to={url}   >
                        <ItemDiscipline code={item.code} description={item.description} />
                    </Dropdown.Item>

                )
            })}
        </>
    )
}

function EventsItems({ discipline, page }) {
    let params = useUrlFriendlyToParameters();
    //Copy object in order to change 
    let paramsURL = { ...params }
    let obj = useGetPath()
    const getURL = useGetURL()
    const dataConfigSport = useGetConfigSports(paramsURL);
    let objUrl = obj(paramsURL.mirs_language);
    if (objUrl.url.isTodayAthMatches || objUrl.url.isTodayMatches || objUrl.url.isTodayTeamMatches) {
        paramsURL["mirs_date"] = ''
    }
    const { mirs_discipline } = params;
    //GET EVENTS
    const data = useGetEvents(params);

    let result = [];
    result = data?.events?.sort((a, b) => a.order - b.order);
    result = result?.filter(event => (event.order !== 0))
    //Remove Division 
    if (mirs_discipline !== 'ATH') {
        result = result?.filter(item => item?.phases?.some(phase => Number(phase.order) > 0));
    }
    //Remove bracket exceptions
    if (page === 'bracket' && dataConfigSport.hasOwnProperty("exceptionBracket")) {
        result = result?.filter(item => !dataConfigSport?.exceptionBracket?.includes(completeRsc(item?.code)))
    }
    let url
    paramsURL["mirs_event"] = ''
    url = getURL(paramsURL, page)
    return (
        <>
            {discipline && <Dropdown.Item id='OcsSubmenuDisciplineList' key={"Selector-Event-Sport"} as={listLinks} to='#' eventKey="sports">{`${discipline}`}</Dropdown.Item>}
            {discipline && <Dropdown.Divider aria-hidden="true" />}
            {discipline && <Dropdown.Item key={"Selector-Event-Sport-All"} as={listLinks} to={url} ><Label data={'LabelAllEvents'} /></Dropdown.Item>}
            {Array.isArray(result) && result.map((item, index) => {
                paramsURL["mirs_event"] = item.code
                url = getURL(paramsURL, page)
                return (
                    <Dropdown.Item key={"Selector-Event-" + item.code + "_" + index} as={listLinks} to={url}   > {/*Change default  element by Link element no use href reload app*/}
                        {item.longDescription}
                    </Dropdown.Item>
                )
            })}
        </>
    )
}

export const NavBarSecondary = () => {
    return (
        <div id='extNavigation'>
            <Navbar expand="lg" id="mirs-second-navigation-bar" aria-labelledby="NavBarSecondary">
                <span id="NavBarSecondary" className="d-none"><Label data={'LabelSportsNav'} /></span>
                <Container>
                    <NavbarSecondaryElements />
                </Container>
            </Navbar>
        </div>
    )
}


/* function PlacingNav() {
    const { mirs_competition, mirs_language, mirs_discipline } = useUrlFriendlyToParameters()
    const getUrl = useGetURL()
    let paramsURL = {}
    paramsURL.mirs_competition = mirs_competition;
    paramsURL.mirs_language = mirs_language;
    paramsURL.mirs_discipline = mirs_discipline;

    let urlPlacing = getUrl(paramsURL, 'placings')

    //Get Data
    const { data } = useQuery(
        {
            queryKey: ['placingTable', mirs_competition, mirs_discipline, mirs_language],
            queryFn: getPlacingsByDiscipline,
            refetchInterval: 60000,
            staleTime: 50000,
            refetchIntervalInBackground: true,
            enabled: mirs_discipline === 'ATH'
        });
    if (data?.placingsBySport) {
        return (<Nav className="ms-auto mb-2 mb-lg-0">
            <Nav.Link as={CustomLink} to={urlPlacing}><Label data={'Placings'} /></Nav.Link>
        </Nav>)
    }
    else {
        return null
    }


} */

/* function NavPoolesBrackets() {
    let paramsURL = useUrlFriendlyToParameters();
    const getUrl = useGetURL()
    const { mirs_rsc, mirs_language, mirs_competition, mirs_discipline } = paramsURL;
    const _event = getEventRSC(mirs_rsc);
    const dataConfigSport = useGetConfigSports(paramsURL);
    const isH2H = dataConfigSport?.isH2H
    paramsURL.mirs_rsc = getLongEventRSC(mirs_rsc)
    const urlPooles = getUrl(paramsURL, 'pool')
    const urlBrackets = getUrl(paramsURL, 'bracket')

    //Load data Phases
    const { data } = useQuery(
        {
            queryKey: ['phasesData', mirs_competition, mirs_language, _event],
            queryFn: getPhases,
            refetchInterval: 0,
        });

    let hasPooles = false
    let hasBrackets = false
    if (isH2H) {
        hasBrackets = true;
        paramsURL.mirs_rsc = getLongEventRSC(mirs_rsc);
        const dataFilter = data ? data.filter(item => item.order === '8') : [];
        hasPooles = dataFilter.length > 0;
    }
    return (
        <>
            {hasBrackets && <Nav className="mb-2 mb-lg-0">
                <Nav.Link as={CustomLink} to={urlBrackets}><Label data={'LabelBrackets'} /></Nav.Link>
            </Nav>}
            {hasPooles && <Nav className="mb-2 mb-lg-0">
                <Nav.Link as={CustomLink} to={urlPooles}><Label data={'HeaderPools'} /></Nav.Link>
            </Nav>}
        </>
    )

} */

export function Expander({ children }) {


    const { expandedComponent } = useContext(MainContainerContext);
    const { open } = expandedComponent
    return (
        <Collapse in={open} >
            <div>{children}</div>
        </Collapse>
    )
}



export const PlaceHolderNavBarSecondary = () => {
    return (
        <Navbar id="mirs-second-navigation-bar">
            <Placeholder as={"div"} className="container" animation="glow">
                <Stack direction="horizontal" gap={2} className='mx-auto w-100' style={{ 'justifyContent': 'center' }}>
                    <Placeholder style={{ height: '3rem' }} className="w-10" />
                    <Placeholder style={{ height: '3rem' }} className="w-10 " />
                    <Placeholder style={{ height: '3rem' }} className="w-10" />
                    <Placeholder style={{ height: '3rem' }} className="w-10 " />
                    <Placeholder style={{ height: '3rem' }} className="w-10" />
                </Stack>

            </Placeholder>
        </Navbar>
    )
};

const isSchOrRec = ({ urlData }) => {
    let out = false
    if (urlData.isSchedule) {
        out = true
    } else if (urlData.isRecords) {
        out = true
    }
    return out
}

export default NavBarSecondary